import images from './images';

const cakes = [
  {
    title: 'Chocolate',
    price: '₹435 | ₹870',
    tags: '1/2 Kg | 1 Kg',
  },
  {
    title: 'Vanilla',
    price: '₹435 | ₹870',
    tags: '1/2 Kg | 1 Kg',
  },
  {
    title: 'Pineapple',
    price: '₹435 | ₹870',
    tags: '1/2 Kg | 1 Kg',
  },
  {
    title: 'Black Forest',
    price: '₹435 | ₹870',
    tags: '1/2 Kg | 1 Kg',
  },
  {
    title: 'Butterscotch',
    price: '₹435 | ₹870',
    tags: '1/2 Kg | 1 Kg',
  },
];

const cakes2 = [
  {
    title: 'Red Velvet',
    price: '₹735 | ₹1470',
    tags: '1/2 Kg | 1 Kg',
  },
  {
    title: "Truffle's",
    price: '₹499 | ₹999',
    tags: '1/2 Kg | 1 Kg',
  },
  {
    title: 'Fudge',
    price: '₹630 | ₹1260',
    tags: '1/2 Kg | 1 Kg',
  },
  {
    title: 'Hazelnut',
    price: '₹630 | ₹1260',
    tags: '1/2 Kg | 1 Kg',
  },
  {
    title: 'Rosted Almond',
    price: '₹735 | ₹1470',
    tags: '1/2 Kg | 1 Kg',
  },
];


export default { cakes, cakes2};
